var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      on: {
        click: function($event) {
          _vm.showMap = !_vm.showMap
        }
      }
    },
    [
      _c(
        "v-layout",
        { staticClass: "event", attrs: { column: "" } },
        [
          _c(
            "chat-user-header",
            {
              attrs: {
                "main-icon": "my_location",
                event: _vm.event,
                participants: _vm.participants
              }
            },
            [
              _vm._v(
                "\n      checked in near " +
                  _vm._s(_vm.event.vicinity) +
                  " at " +
                  _vm._s(_vm._f("formatDate")(_vm.event.timestamp)) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "text-xs-left event-line ml-1",
              attrs: { xs12: "", sm12: "", "align-center": "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                }
              }
            },
            [
              _vm.showMap
                ? _c("load-map", {
                    attrs: {
                      width: "100%",
                      height: "250px",
                      load: _vm.load,
                      "position-markers": _vm.checkinEvents,
                      "origin-place-id": _vm.originPlaceId,
                      "destination-place-id": _vm.destinationPlaceId
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showTime
        ? _c(
            "v-flex",
            {
              staticClass:
                "text-sm-right text-sm-left event-line font-weight-light caption pr-2",
              attrs: { xs12: "", sm2: "" }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm._f("formatDate")(_vm.event.timestamp)))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-event pr-2" },
        [
          !_vm.showMap ? _c("v-icon", [_vm._v("map")]) : _vm._e(),
          _vm._v(" "),
          _vm.showMap
            ? _c("v-icon", [_vm._v("\n      minimize\n    ")])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-475fe1b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475fe1b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/UserCheckinEvent.vue
// module id = null
// module chunks = 